import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroSection() {
  const featured = comics.slice(0, 4);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Chinese%20manga%20style%20illustration%20with%20soft%20peach%20blossom%20petals%20floating%20in%20spring%20breeze%2C%20warm%20pink%20and%20golden%20light%2C%20dreamy%20atmosphere%2C%20anime%20background%20art%2C%20gentle%20bokeh%20effect%2C%20ethereal%20and%20romantic%20mood%2C%20pastel%20tones&width=1600&height=900&seq=hero-bg-home&orientation=landscape"
        alt="蜜桃少年漫画 - 漫画全集免费阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-3 md:mb-4 text-center">
          蜜桃少年漫画
        </h1>
        <p className="text-sm md:text-lg text-white/80 mb-6 md:mb-8 text-center max-w-2xl">
          漫画全集免费阅读下拉式 — 在土豪漫画网体验蜜桃少年，在线下拉浏览完整故事，享受免费且流畅的阅读乐趣
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/comic/mitao-shaonian"
            className="px-6 py-2.5 md:px-8 md:py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-colors text-sm md:text-base whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/category/shaonian"
            className="px-6 py-2.5 md:px-8 md:py-3 bg-white/20 hover:bg-white/30 text-white font-medium rounded-full transition-colors text-sm md:text-base whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            浏览分类
          </Link>
        </div>

        <div className="hidden lg:grid grid-cols-4 gap-4 mt-10 w-full max-w-4xl">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="flex items-center gap-3 p-3 rounded-lg bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-colors cursor-pointer"
            >
              <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0">
                <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="min-w-0">
                <p className="text-xs font-semibold text-white truncate">{comic.title}</p>
                <p className="text-xs text-white/60 truncate">{comic.author}</p>
                <div className="flex items-center gap-1 mt-0.5">
                  <span className="text-yellow-400 text-xs">★</span>
                  <span className="text-xs text-white/80">{comic.rating}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}